/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { PresetItemCreate } from './presetItemCreate';

export interface PresetAppendItemsRequest {
  /** @minItems 1 */
  items: PresetItemCreate[];
}
